<template>
	<div class="">
		<Header></Header>
		<div class="Courdesystem_detail w95">
		 <div class="miansbox">
			  <p v-html="datalist.content">
			  
		      </p>
		 </div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'Courdesystem_detail',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
				  id:this.$route.params.id,
				  datalist:{}
			}

		},
		methods: {
               getDetailinfo(){
			    this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                var that = this;
				this.$axios.get(__Config.api.getclassTypeinfo+this.id,{
				
				})
				.then(function (res) {
				    that.datalist= res.data.data;
					that.$toast.clear();
				
				})
				.catch(function (err) {
					 that.$toast.clear();
					console.log(err);
				});
		  },
		},
		created(){
			 this.getDetailinfo();
		}
	}
</script>

<style scoped>
.Courdesystem_detail{
	width: 100%;
	margin: 20px auto;
}
.miansbox{
	width: 98%;
	margin: 0  auto;
	overflow-x: scroll;
}
.miansbox p img{
	width: 100%;
	height: 100%;
}
.Courdesystem_detail p{
	margin: 13px;
	font-size: 14px;
	color: #666;
	line-height:22px;
}
</style>



// WEBPACK FOOTER //
// src/components/Courdesystem_detail.vue